import axios from '../../axios'

/*
 * 字典管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/system/sysDict/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/system/sysDict/delete',
        method: 'post',
        data
    })
}
//查看
export const view = (data) => {
  return axios({
    url: '/system/sysDict/view',
    method: 'post',
    data
  })
}
//编辑
export const edit = (data) => {
  return axios({
    url: '/system/sysDict/edit',
    method: 'post',
    data
  })
}
// 分页查询
export const list = (data) => {
    return axios({
        url: '/system/sysDict/list',
        method: 'post',
        data
    })
}

export const dictDetailList = (data) => {
  return axios({
    url: '/system/sysDict/dictDetailList',
    method: 'post',
    data
  })
}

export const saveDictDetail = (data) => {
  return axios({
    url: '/system/sysDictDetail/save',
    method: 'post',
    data
  })
}
export const dictDetailDelete = (data) => {
  return axios({
    url: '/system/sysDictDetail/delete',
    method: 'post',
    data
  })
}
export const dictDetailEdit = (data) => {
  return axios({
    url: '/system/sysDictDetail/edit',
    method: 'post',
    data
  })
}
// 根据字典编码获取字典数据
export const getDictsByCode = (data) => {
  return axios({
    url: '/system/sysDict/getDictsByCode',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sys/dict.js